import React from 'react';
import LoginForm from './login';

const Login: React.FC = () => <LoginForm allowRedirect={true} />;

export default Login;
